import { atom } from "recoil";

export const isLoginState = atom({ key: 'isLogin', default: false });
export const loginEmailState = atom({ key: 'loginEmail', default: null });